import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import ContactsManagementPage from './ContactsManagementPage';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

export default function SeniorContactsPage() {
  const { seniorId } = useParams();
  const navigate = useNavigate();
  const [senior, setSenior] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSenior();
  }, [seniorId]);

  const fetchSenior = async () => {
    try {
      const response = await axios.get(`${API}/api/seniors/${seniorId}`);
      setSenior(response.data);
    } catch (error) {
      console.error('Error fetching senior:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-[#0B0F1E] flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-violet-500 mx-auto mb-4"></div>
          <p className="text-gray-400">Laden...</p>
        </div>
      </div>
    );
  }

  return (
    <ContactsManagementPage
      seniorId={seniorId}
      seniorName={senior?.name}
      onClose={() => navigate('/family/dashboard')}
    />
  );
}
